<template>
    <div class="wrapper">
        <div class="answer-btn-group" v-if="robotId === 'exercises' || robotId === 'mexercises'">

            <button v-if="!isChooseType(question)" type="primary" size="mini" :disabled="question.isLoading"
                @click="question.showAnserPanel = true">
                我要答题
            </button>
            <button type="primary" size="mini" :disabled="question.isLoading"
                @click="submitAnswer(question, chat.level)">
                提交答案
            </button>
            <button type="primary" size="mini" :disabled="question.isLoading" @click="showAnswer(question, chat.level)"
                v-if="!isChooseType(question)">
                查看答案
            </button>
            <button type="primary" size="mini" :disabled="question.isLoading"
                @click="showExplain(question, chat.level)">
                老师讲解
            </button>
            <button type="primary" size="mini" :disabled="question.isLoading" @click="recommandTopic(question)">
                相似题
            </button>
        </div>
        <div class="answer-btn-group" v-else-if="robotId === 'composition'">
            <el-select :popper-append-to-body="true" v-if="!isChooseType(question)" style="width: 120px"
                placeholder="答题" class="handler-select" :value="question.btn" :disabled="question.isLoading"
                @change="handleOperateChange" @click.native.stop @touchstart.native.stop>
                <el-option label="请选择" value=""></el-option>
                <el-option label="我要答题" value="toAnswer"></el-option>
                <el-option label="提交答案" value="submitAnswer"></el-option>
                <el-option label="查看答案" value="showAnswer"></el-option>
                <el-option label="老师讲解" value="showExplain"></el-option>
            </el-select>
            <el-select :popper-append-to-body="true" v-if="isChooseType(question)" @click.native.stop
                @touchstart.native.stop style="width: 120px" :value="question.btn" class="handler-select"
                placeholder="答题" :disabled="question.isLoading" @change="handleOperateChange">
                <el-option label="请选择" value=""></el-option>
                <el-option label="提交答案" value="submitAnswer"></el-option>

                <el-option label="老师讲解" value="showExplain"></el-option>
            </el-select>
            <button type="primary" size="mini" :disabled="question.isLoading"
                @click="replaceQuestion(question, chat, index)">
                相似题替换
            </button>
            <button type="primary" size="mini" :disabled="question.isLoading" @click="openPointForm">
                知识点替换
            </button>

            <button type="primary" size="mini" :disabled="question.isLoading" @click="getReplaceList(question, chat)">
                收藏本替换
            </button>
            <el-tooltip class="item" effect="dark" placement="top" content="下方增加一道题">
                <i class="el-icon-circle-plus-outline question-btn" @click="openPointAddDialog"></i>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" placement="top" content="删除本题">
                <i class="el-icon-remove-outline question-btn" @click="openPointDeleteDialog"></i>
            </el-tooltip>

            <el-dialog title="根据知识点换题" width="40%" top="16vh" class="replaceByPointDialog" size="large"
                :key="question.nanoid + 'point'" :visible.sync="question.pointFormVisible" :append-to-body="true">
                <el-input class="knowledge-point" v-model="question.knowledgePoint" autocomplete="off"
                    placeholder="请输入知识点" type="textarea" :autosize="{ minRows: 5, maxRows: 11 }"
                    ref="pointRef"></el-input>
                <div slot="footer" class="dialog-footer base-button">
                    <button @click="question.pointFormVisible = false" style="margin-right: 10px">
                        取 消
                    </button>
                    <button type="primary" @click="
                        replaceQuestionByPoint(index, question, chat)
                        ">
                        提 交
                    </button>
                </div>
            </el-dialog>
            <el-dialog title="根据收藏本换题" top="7vh" class="collectDialog" size="large"
                :visible.sync="question.collectFormVisible" :append-to-body="true">
                <div class="collect-loading" v-loading="question.isLoading"></div>
                <div v-if="
                    !collectList && !question.isLoading
                ">
                    收藏本暂无类似相似题
                </div>
                <el-radio-group :ref="question.nanoid + 'CollectPanel'" class="collect-radio-group" v-else
                    v-model="question.collectReplace">
                    <div v-for="(q, qIdx) in collectList" :key="'collect_q' + q.nanoid">
                        <div class="dialog-collects" :class="index % 2 === 0 ? 'even' : 'odd'">
                            <el-radio :label="q" class="collect-radio question-item">
                                &nbsp;</el-radio>
                            <Question :question="q" :showIndex="qIdx" :index="index" :chat="chat" :hideToolbar="true"
                                :key="q.nanoid" @sendEditorAnswer="() => { }">
                            </Question>
                        </div>
                    </div>

                </el-radio-group>
                <div slot="footer" class="dialog-footer base-button">
                    <button @click="closeCollectDialog(question)" style="margin-right: 10px">
                        取 消
                    </button>
                    <button type="primary" @click="
                        replaceQuestionByCollect(
                            question,
                            index,
                            chat
                        )
                        ">
                        提 交
                    </button>
                </div>
            </el-dialog>

        </div>
        <div v-else>

        </div>

    </div>
</template>
<script>
import drawSvg from "@/assets/image/icon/draw.svg";
import humenAvatar from "@/assets/image/chat/humen.svg";
import Question from "@/components/question/question.vue";
import { createAutoMsg } from '@/utils/chat/autoMsg'
import { initQuestion, initQuestionForList } from "@/utils/question/QuestionInitializer"

import * as chatApi from "@/api/chat/sendReceive";


import {
    ApiService
} from "@/api/fetch/apiService"
import { resetQuestionStandardAnswer, resetAnswer } from "@/utils/question/AnswerService"
import { mapState } from "vuex/dist/vuex.common.js";
import store from "../../store";


export default {
    name: 'QuizInteractionToolbar',
    data() {
        return {
            drawSvg,
            collectList: {}
        }
    },
    components: {
        Question
    },
    props: ["robotId", "question", "chat", "index"],
    inject: ['callGrandfatherAddQuestion', "callGrandfatherRemoveQuestion", "callGrandfatherUpdateQuestion"],
    computed: {

        ...mapState(["robots", "sessionId"])

    },

    mounted() {
        // lifecycle hook
    },

    methods: {

        // 判断当前题目的类型（单选、多选、判断、填空、简答、问答）
        isChooseType(question) {
            if (["SQ", "FIB"].includes(question.question_type)) {
                return false;
            } else {
                return true;
            }
        },
        renderMarkdown(data) {
            return mdRenderData(data);
        },


        // 答题
        toAnswer() {
            this.question.showAnserPanel = true;
        },

        // 提交答案
        submitAnswer(question, level) {
            let { id, userAnswer } = question;
            let answer = userAnswer;
            // 选择题
            if (userAnswer instanceof Array) {
                if (userAnswer.length === 0) {
                    this.$message.warning("答案不能为空");
                    question.btn = "";
                    return;
                }
                answer = userAnswer.sort().join(",").replaceAll(",", "");
                // 填空简答题
            } else if (!userAnswer.trim()) {
                this.$message.warning("答案不能为空");
                question.btn = "";
                return;
            }
            resetQuestionStandardAnswer(question)
            question.isViweAnswerCollapse = ""
            question.isTeacherEpxlCollapse = ""
            question.isLoading = true;
            question.level = level
            // this.handleQuestionScroll(question);
            ApiService.fetchSubmitAnswer({
                id,
                answer,
                question,
            });
        },
        // 查看答案
        showAnswer(question, level) {
            resetAnswer(question, "viewAnswer")
            question.isTeacherEpxlCollapse = "";
            question.isStandardEpxlCollapse = "";
            question.isLoading = true;
            let { id } = question;
            // this.handleQuestionScroll(question);
            question.level = level;
            ApiService.fetchViewAnswer({
                id,
                question,
            });
        },
        // 老师讲解
        showExplain(question, level) {
            let { id } = question;
            question.teacher_expl = ""
            this.callGrandfatherUpdateQuestion(question, "isLoading", true)
            question.isStandardEpxlCollapse = "";
            question.isViweAnswerCollapse = "";
            question.level = level
            // 设置question的滚动问题
            // this.handleQuestionScroll(question);
            ApiService.fetchTeacherExplain({
                id,
                question,
            });
        },

        // 下拉相应的操作
        handleOperateChange(val) {
            let question = this.question
            let level = this.chat.level
            if (this[val]) {
                this[val](question, level);
            }
            this.callGrandfatherUpdateQuestion(question, "btn", "")

        },

        // 打开知识点替换窗口

        openPointForm() {
            this.question.pointFormVisible = true;
        },

        // 打开草稿纸
        openRoughPaper() {
            this.question.roughPaperShow = true
        },



        // 推荐相似题
        async recommandTopic(question) {
            this.callGrandfatherUpdateQuestion(question, "isLoading", true)
            let { sessionId, robotId } = this;
            let myMsg = {
                type: "my",
                msg: "推荐相似题",
                fileList: [],
                avatar: humenAvatar,
                robotId,
                sessionId
            };
            let electricaiMsg = createAutoMsg(
                this.robots[robotId].avatar,
                this.$delete
            );
            electricaiMsg.retry = ApiService.fetchSimilarQuestions;
            electricaiMsg.remmandType = "similar";
            electricaiMsg.robotId = robotId;
            electricaiMsg.sessionId = sessionId;
            let originMsg = _.clone(electricaiMsg)
            electricaiMsg.params = {
                question,
                aiContent: originMsg,
            };

            // this.$store.commit("UPDATE_MESSAGE", {
            //     robotId: robotId,
            //     key: sessionId,
            //     msg: myMsg,
            // });

            // this.$store.commit("UPDATE_MESSAGE", {
            //     robotId: robotId,
            //     key: sessionId,
            //     msg: electricaiMsg,
            // });

            await this.$store.dispatch('addMessageToConversation', {
                message: myMsg
            });
            await this.$store.dispatch('addMessageToConversation', {
                message: electricaiMsg
            });

            ApiService.fetchSimilarQuestions({
                question,
                aiContent: electricaiMsg,
            });
        },
        // 直接更换题目
        async replaceQuestion(question, chat, index) {
            if (question.isLoading) return;
            this.callGrandfatherUpdateQuestion(question, "isLoading", true)
            const { data: res } = await chatApi.replaceQuestion({ id: question.id, level: chat.level });
            question.isLoading = false;
            if (!res || !res.questions) {
                this.$message.error("相似题替换失败");
                return;
            }
            let type = res.questions[0].question_type
            chat.paperCollect = false;
            let questions = initQuestion(res.questions, null, index);
            const newQuestion = questions[type].questions[0]
            chat.questions[type].questions.splice(index, 1, newQuestion);
            store.dispatch("updateMessageToConversation", {
                message: chat
            })
        },

        async getReplaceList(question, chat) {
            if (question.isLoading) return;
            this.collectList = {};
            question.collectFormVisible = true;
            this.callGrandfatherUpdateQuestion(question, "isLoading", true)
            let res = await chatApi.getReplaceList({ id: question.id, level: chat.level });
            this.callGrandfatherUpdateQuestion(question, "isLoading", false)
            if (!res || res.status != 200) {
                return;
            }

            this.$nextTick(() => {
                let ele = this.$refs[question.nanoid + 'CollectPanel']
                if (ele) {
                    this.handleImageLoad(ele.$el)

                }
            })
            if (!res.data) {
                this.$message.info("题目收藏本里不存在同类型题目！");
                return;
            }
            if (res.data.questions.length == 0) {
                this.$message.info("题目收藏本里不存在同类型题目！");
                return;
            }
            this.collectList = initQuestionForList(res.data.questions, "questionCollect");
        },

        // 关闭对话框
        closeCollectDialog(question) {
            this.callGrandfatherUpdateQuestion(question, "collectFormVisible", false)
        },


        // 打开添加题目的弹窗
        openPointAddDialog() {

            this.callGrandfatherAddQuestion(this.index, this.question, this.chat)

        },
        // 打开删除题目的弹窗
        openPointDeleteDialog() {
            this.callGrandfatherRemoveQuestion(this.index, this.question, this.chat)
        },
        async handleImageLoad(ele) {
            await this.$nextTick();
            let images = []
            if (ele) {
                images = ele.querySelectorAll("img");

            } else {
                images = document.querySelectorAll("img");

            }
            if (!images || images.length < 1) return;
            images.forEach((img) => {
                let count = 0;
                img.onerror = function () {
                    count++;
                    let retryTimer;
                    const retryLoad = () => {
                        const src = img.src;
                        const timestamp = new Date().getTime();
                        img.src = `${src}?${timestamp}`;
                    };
                    retryTimer = setTimeout(() => {
                        retryLoad();
                    }, 500);
                    if (count >= 10) {
                        clearTimeout(retryTimer);
                        return;
                    }
                    // 当图片最终加载成功时，清除定时器，避免重复执行
                    img.onload = function () {
                        clearTimeout(retryTimer);
                    };
                };

            });
        },

        // 根据收藏列表替换题目
        replaceQuestionByCollect(question, index, chat) {
            if (
                !question.collectReplace ||
                Object.keys(question.collectReplace).length === 0
            ) {
                this.$message.warning("您未选择替换的题目，请选择后点击替换");
                return;
            }

            let questions = initQuestion(
                [question.collectReplace],
                "collectReplace",
                index
            );
            let type = question.question_type
            const newQuestion = questions[type].questions[0]
            chat.paperCollect = false;
            chat.questions[type].questions.splice(index, 1, newQuestion);
            question.collectFormVisible = false;
            store.dispatch("updateMessageToConversation", {
                message: chat
            })
        },

        // 根据知识点换题
        async replaceQuestionByPoint(index, question, chat) {
            question.pointFormVisible = false;
            if (question.isLoading) return;
            question.isLoading = true;
            const { data: res } = await chatApi.replaceByKnowledge({
                id: question.id,
                query: question.knowledgePoint,
                level: chat.level
            });
            question.isLoading = false;
            if (!res || !res.questions) {
                this.$message.error("知识点替换失败");
                return;
            }
            chat.paperCollect = false;
            let questions = initQuestion(res.questions, null, index);
            let type = res.questions[0].question_type
            const newQuestion = questions[type].questions[0]
            newQuestion.knowledgePoint = question.knowledgePoint;
            chat.questions[type].questions.splice(index, 1, newQuestion);
            store.dispatch("updateMessageToConversation", {
                message: chat
            })
        },

    }
}
</script>

<style lang="scss" scoped>
.QuizInteractionToolbar {
    /* styles */
}

.answer-btn-group {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 12px;
    padding-left: 12px;
    text-align: center;

    div {
        // margin-left: 10px;
    }

    button {
        margin-right: 10px;
    }

    .rough-icon {
        font-size: 24px;          // 与原来图片大小接近
        cursor: pointer;
        color: #20b2aa;           // 青绿色（LightSeaGreen）
        transition: all 0.2s ease;
        margin-right: 12px;

        &:hover {
            color: #2e8b57;       // 悬停时变为海绿（SeaGreen），也可改为更亮的青绿
            transform: scale(1.05); // 可选：轻微放大
        }
    }

    .el-select {
        margin-right: 10px;

        ::v-deep .el-input__inner {
            height: 34px !important;
        }
    }

    .el-select-dropdown__item {
        padding: 0 10px;
        font-size: 12px;
    }

    .question-btn {
        font-size: 26px;
        cursor: pointer;
        margin-right: 6px;
        font-weight: 600;
        opacity: .8;            // 可微调，使颜色更明显
        color: #20b2aa;         // 青绿色（与草稿纸图标一致）

        &:hover {
            color: #2e8b57;     // 悬停时加深（海绿色）
            opacity: 1;
        }
    }
}

::v-deep .el-textarea__inner {
    background-color: var(--dialog-bg-color);
    color: var(--txt-default-color);
}

.collectDialog {
    ::v-deep .el-dialog {
        max-width: 70rem;
        min-width: 60%;

        .el-dialog__body {
            min-height: 180px;
            max-height: 80vh;
            overflow: auto;
            display: flex;
            justify-content: center;
            align-items: center;

            .collect-loading {
                text-align: center;
            }

            .el-loading-parent--relative {
                position: absolute !important;
            }


        }
    }

}

.replaceByPointDialog {
  ::v-deep .el-dialog {
    max-width: 78rem;
    min-width: 60%;

    .el-dialog__body {
      min-height: 180px;
      max-height: 80vh;
      overflow: auto;
      display: flex;
      justify-content: center;
      align-items: center;

      .collect-loading {
        text-align: center;
      }

      .el-loading-parent--relative {
        position: absolute !important;
      }
    }
  }
}

button {
    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;

        &:hover {
            transform: translateY(0);
            box-shadow: none;
        }
    }
}

.collect-radio-group {
    padding: 0 20px;
    width: 90%;
    max-height: 72vh;
    display: flex;
    flex-direction: column;

    .dialog-collects {
        display: flex;
        align-items: baseline;
        flex: 8;
        padding: 0 20px;
        background-color: var(--question-dialog-bgcolor, #2b2e30);
        border-bottom: 1px solid var(--hover-color, #434346);
        color: var(--txt-default-color);

        &:last-of-type {
            border-bottom: none;
        }

        &.odd {}

        &.even {}

        &:hover {
            // box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
            //   0 2px 4px 0 rgba(232, 237, 250, 0.5);
            background-color: var(--hover-color, #434346);
        }

        ::v-deep .collect-radio {
            margin-right: 5px;
            padding-left: 5px;
            width: 12px;

            &.is-checked .el-radio__inner {
                border-color: $base_color;
                background: $base_color;
            }
        }
    }
}

@media (max-width:1024px) {
    .el-select-dropdown__item {
        display: flex;
        justify-content: center;
        padding-left: 8px;
        font-size: 12px;
    }

    .el-select__caret {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .answer-btn-group {
        margin-top: 5px;
        margin-bottom: 8px;

        button {
            margin-right: 0.2rem !important;
            // padding: 6px 8px;
            font-size: clamp(10px, 0.12rem, 18px);

        }

        .el-select {
            margin-right: 0.1rem;


        }


        .rough-icon {
            width: 12px !important;
            height: 12px;
            margin-right: 14px !important;

        }
    }

    .collect-radio-group {
        padding: 0;
        width: 100%;
    }

    .collectDialog {
        overflow: hidden;

        ::v-deep .click-enlarge {
            pointer-events: none;
        }

        ::v-deep .el-dialog {
            margin-top: 1vh !important;
            width: 95vw !important;
            transform: scale(1);

            .dialog-collects {
                padding: 0 0.1rem !important;

            }

            .serial-number {
                font-size: $font_size !important;
            }

            .el-radio__inner {
                width: $font_size;
                height: $font_size;
            }

        }

        ::v-deep .el-dialog__body {
            height: 45vh !important;
            max-height: 60vh !important;
            padding-left: 0;
            padding-right: 0;
            padding-top: 2vh !important;
        }

        ::v-deep .el-dialog__footer {
            padding: 10px;
            padding-top: 15px;
            padding-bottom: 15px;
        }

        ::v-deep .el-radio__inner {
            // margin-top: 5px !important;
        }




    }

  .replaceByPointDialog {
    height: fit-content !important;

    ::v-deep .el-dialog {
      margin-top: 12vh !important;
      width: 90% !important;

      .el-dialog__body {
        padding-top: 15px;
        padding-bottom: 15px;
        height: auto !important;
        min-height: fit-content;

        .el-textarea__inner {
          margin: 0 auto;
          width: 95%;
          max-height: 420px;
        }
      }

      .el-dialog__footer {
        padding: 0 24px 20px;
      }
    }
  }
}

@media (max-width: 750px) {
    .answer-btn-group {
        button {
            padding: 8px;
            margin-right: 3px !important;
        }

        .el-select {
            width: 60px !important;
            margin-left: 0 !important;



            ::v-deep .el-input__inner {
                padding: 0 7px;
                height: 28px !important;
            }
        }


        .question-btn {
            margin-right: 3px !important;
            font-size: 22px !important;
        }

        .rough-icon {
            margin-right: 14px !important;
        }

    }
}
</style>